/**
 * EarlyBird Quiz Module
 * Version: 1.0.0
 * 
 * Dependencies: GA4 gtag.js (optional but recommended)
 */

(function() {
    'use strict';
  
    // ==========================================
    // QUIZ ANALYTICS MODULE
    // ==========================================
    const QuizAnalytics = {
      quizName: 'earlybird_morning_assessment',
      enableGA4: true,
      enableMeta: true,
      sessionId: null,
  
      init(config) {
        this.quizName = config.quizName || this.quizName;
        this.enableGA4 = config.enableGA4 !== false;
        this.enableMeta = config.enableMeta !== false;
        this.sessionId = this.getOrCreateSessionId();
      },
  
      getOrCreateSessionId() {
        let sessionId = sessionStorage.getItem('eb_quiz_session');
        if (!sessionId) {
          sessionId = 'ebq_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
          sessionStorage.setItem('eb_quiz_session', sessionId);
        }
        return sessionId;
      },
  
      getTrafficSource() {
        const params = new URLSearchParams(window.location.search);
        return {
          source: params.get('utm_source') || 'direct',
          medium: params.get('utm_medium') || 'none',
          campaign: params.get('utm_campaign') || 'none'
        };
      },
  
      track(eventName, eventData) {
        const payload = {
          quiz_name: this.quizName,
          session_id: this.sessionId,
          send_to: 'G-ZGLGC31Z7B',
          ...eventData
        };
  
        // GA4 Tracking
        if (this.enableGA4 && typeof gtag === 'function') {
          gtag('event', eventName, payload);
        }
  
        // Meta Pixel Tracking
        if (this.enableMeta && typeof fbq === 'function') {
          fbq('trackCustom', eventName, payload);
        }
  
        // Debug logging
        if (window.location.hostname === 'localhost' || window.location.search.includes('debug=true')) {
          console.log('[EarlyBird Quiz]', eventName, payload);
        }
      },
  
      trackQuizStart() {
        const traffic = this.getTrafficSource();
        this.track('quiz_start', {
          traffic_source: traffic.source,
          traffic_medium: traffic.medium,
          traffic_campaign: traffic.campaign,
          page_url: window.location.pathname
        });
      },
  
      trackQuestionView(questionNumber, questionId, questionType) {
  // Fire unique event name for each question (guaranteed funnel compatibility)
  this.track(`quiz_q${questionNumber}_view`, {
    question_id: questionId,
    question_type: questionType
  });
  
  // Also fire generic event with parameter (for flexibility)
  this.track('quiz_question_view', {
    question_number: questionNumber,
    question_id: questionId,
    question_type: questionType
  });
},
  
      trackQuestionAnswer(questionNumber, questionId, answer, timeOnQuestion) {
        const sanitizedAnswer = Array.isArray(answer) 
          ? answer.join(' | ').substring(0, 200)
          : String(answer).substring(0, 200);
  
        this.track('quiz_question_answer', {
          question_number: questionNumber,
          question_id: questionId,
          answer_value: sanitizedAnswer,
          time_on_question_seconds: Math.round(timeOnQuestion / 1000)
        });
      },
  
      trackSegment(segmentName, segmentValue) {
        this.track('quiz_segment', {
          segment_name: segmentName,
          segment_value: segmentValue
        });
  
        if (this.enableMeta && typeof fbq === 'function') {
          fbq('trackCustom', 'QuizSegment_' + segmentName, { segment: segmentValue });
        }
      },
  
      trackQuizComplete(answers, profileType, totalTime) {
        this.track('quiz_complete', {
          morning_profile: profileType,
          urgency_score: answers.urgency || 0,
          commitment_level: answers.commitment || '',
          total_questions: Object.keys(answers).length,
          total_time_seconds: Math.round(totalTime / 1000)
        });
  
        if (this.enableMeta && typeof fbq === 'function') {
          fbq('track', 'CompleteRegistration', {
            content_name: this.quizName,
            status: 'complete',
            value: answers.urgency || 7
          });
        }
  
        this.storeForAttribution(answers, profileType);
      },
  
      trackQuizAbandon(lastQuestionNumber, lastQuestionId, totalTime) {
        this.track('quiz_abandon', {
          last_question_number: lastQuestionNumber,
          last_question_id: lastQuestionId,
          questions_completed: lastQuestionNumber - 1,
          total_time_seconds: Math.round(totalTime / 1000)
        });
      },
  
      trackCTAClick(ctaType, profileType) {
        this.track('quiz_cta_click', {
          cta_type: ctaType,
          morning_profile: profileType
        });
  
        if (this.enableMeta && typeof fbq === 'function') {
          fbq('track', 'AddToCart', {
            content_name: 'EarlyBird Morning Cocktail',
            content_category: 'Quiz Result',
            value: 49.00,
            currency: 'USD'
          });
        }
      },
  
      storeForAttribution(answers, profileType) {
        const quizData = {
          sessionId: this.sessionId,
          profile: profileType,
          segment: this.getSegmentFromAnswers(answers),
          urgency: answers.urgency,
          commitment: answers.commitment,
          completedAt: new Date().toISOString()
        };
        
        localStorage.setItem('eb_quiz_data', JSON.stringify(quizData));
        document.cookie = `eb_quiz_profile=${profileType}; path=/; max-age=2592000`;
        document.cookie = `eb_quiz_segment=${quizData.segment}; path=/; max-age=2592000`;
      },
  
      getSegmentFromAnswers(answers) {
        const struggleMap = {
          "I hit snooze 3-6 times and can't get out of bed": 'snooze_warrior',
          "I wake up with brain fog that takes hours to clear": 'fog_fighter',
          "I crash hard around 2-3pm no matter how much coffee I drink": 'crash_survivor',
          "I feel jittery and anxious from too much caffeine": 'jitter_escaper'
        };
        return struggleMap[answers.struggle] || 'unknown';
      }
    };
  
    // ==========================================
    // QUIZ UI MODULE
    // ==========================================
    class EarlyBirdQuiz {
      constructor(container) {
        this.container = container;
        this.config = this.loadConfig();
        this.currentStep = 0;
        this.answers = {};
        this.questionStartTime = Date.now();
        this.quizStartTime = Date.now();
        this.sliderValue = 7;
        this.completed = false;
  
        this.elements = {
          quizContainer: container.querySelector('[data-quiz-container]'),
          questionContainer: container.querySelector('[data-question-content]'),
          progressFill: container.querySelector('[data-progress-fill]'),
          currentStepEl: container.querySelector('[data-current-step]'),
          totalStepsEl: container.querySelector('[data-total-steps]'),
          backBtn: container.querySelector('[data-action="back"]'),
          continueBtn: container.querySelector('[data-continue-btn]'),
          brandHeader: container.querySelector('[data-brand-header]'),
          loadingScreen: container.querySelector('[data-loading-screen]'),
          loadingProgress: container.querySelector('[data-loading-progress]'),
          loadingText: container.querySelector('[data-loading-text]'),
          testimonialQuote: container.querySelector('[data-testimonial-quote]'),
          testimonialAuthor: container.querySelector('[data-testimonial-author]'),
          resultsScreen: container.querySelector('[data-results-screen]')
        };
  
        this.init();
      }
  
      loadConfig() {
        const configEl = this.container.querySelector('[data-quiz-config]');
        if (configEl) {
          try {
            return JSON.parse(configEl.textContent);
          } catch (e) {
            console.error('Failed to parse quiz config:', e);
          }
        }
        return { questions: [], results: {}, testimonials: [] };
      }
  
      init() {
        QuizAnalytics.init({
          quizName: this.container.dataset.quizName,
          enableGA4: this.container.dataset.enableGa4 !== 'false',
          enableMeta: this.container.dataset.enableMeta !== 'false'
        });
  
        this.elements.totalStepsEl.textContent = this.config.questions.length;
        this.bindEvents();
        QuizAnalytics.trackQuizStart();
        this.renderQuestion();
        window.addEventListener('beforeunload', () => this.handleAbandon());
      }
  
      bindEvents() {
        this.elements.backBtn.addEventListener('click', () => this.goBack());
        this.elements.continueBtn.addEventListener('click', () => this.goNext());
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' && this.elements.continueBtn.classList.contains('eb-quiz__continue-btn--active')) {
            this.goNext();
          }
        });
      }
  
      renderQuestion() {
        const question = this.config.questions[this.currentStep];
        if (!question) return;
  
        this.updateProgress();
        QuizAnalytics.trackQuestionView(this.currentStep + 1, question.id, question.type);
        this.questionStartTime = Date.now();
        this.elements.brandHeader.style.display = this.currentStep === 0 ? 'block' : 'none';
        this.elements.backBtn.style.visibility = this.currentStep > 0 ? 'visible' : 'hidden';
  
        let html = '';
        switch (question.type) {
          case 'single': html = this.renderSingleSelect(question); break;
          case 'multi': html = this.renderMultiSelect(question); break;
          case 'breather': html = this.renderBreather(question); break;
          case 'education': html = this.renderEducation(question); break;
          case 'slider': html = this.renderSlider(question); break;
        }
  
        this.elements.questionContainer.innerHTML = html;
        this.elements.questionContainer.parentElement.style.animation = 'none';
        this.elements.questionContainer.parentElement.offsetHeight;
        this.elements.questionContainer.parentElement.style.animation = 'eb-fadeIn 0.4s ease';
  
        this.bindOptionEvents(question);
        this.updateContinueButton(question);
      }
  
      renderSingleSelect(question) {
        return `
          <h2 class="eb-quiz__question-title">${this.escapeHtml(question.question)}</h2>
          ${question.subtitle ? `<p class="eb-quiz__question-subtitle">${this.escapeHtml(question.subtitle)}</p>` : ''}
          <div class="eb-quiz__options">
            ${question.options.map((option, i) => `
              <button class="eb-quiz__option" data-option-index="${i}" data-option-value="${this.escapeHtml(option)}">
                ${this.escapeHtml(option)}
              </button>
            `).join('')}
          </div>
        `;
      }
  
      renderMultiSelect(question) {
        const selected = this.answers[question.id] || [];
        return `
          <h2 class="eb-quiz__question-title">${this.escapeHtml(question.question)}</h2>
          ${question.subtitle ? `<p class="eb-quiz__question-subtitle">${this.escapeHtml(question.subtitle)}</p>` : ''}
          <div class="eb-quiz__options">
            ${question.options.map((option, i) => `
              <button class="eb-quiz__option ${selected.includes(option) ? 'eb-quiz__option--selected' : ''}" 
                      data-option-index="${i}" data-option-value="${this.escapeHtml(option)}" data-multi="true">
                <span class="eb-quiz__checkbox"><span class="eb-quiz__checkbox-icon">✓</span></span>
                ${this.escapeHtml(option)}
              </button>
            `).join('')}
          </div>
        `;
      }
  
      renderBreather(question) {
        return `
          <div class="eb-quiz__breather">
            <h2 class="eb-quiz__breather-title">You're not alone.</h2>
            <div class="eb-quiz__breather-stats">
              ${question.stats.map(stat => `
                <div class="eb-quiz__breather-stat">
                  <span class="eb-quiz__breather-stat-number">${stat.number}</span>
                  <span class="eb-quiz__breather-stat-label">${stat.label}</span>
                </div>
              `).join('')}
            </div>
            <div class="eb-quiz__breather-testimonial">
              <p class="eb-quiz__breather-quote">"${this.escapeHtml(question.testimonial.quote)}"</p>
              <p class="eb-quiz__breather-author">— ${this.escapeHtml(question.testimonial.author)}, <span>${this.escapeHtml(question.testimonial.title)}</span></p>
            </div>
            <button class="eb-quiz__continue-btn eb-quiz__continue-btn--active" data-breather-continue>Continue →</button>
          </div>
        `;
      }
  
      renderEducation(question) {
        return `
          <div class="eb-quiz__education">
            <h2 class="eb-quiz__education-title">${this.escapeHtml(question.title)}</h2>
            <div class="eb-quiz__education-card">
              <div class="eb-quiz__education-emoji">☕ + 📈 = 💥</div>
              <p class="eb-quiz__education-content">${this.escapeHtml(question.content)}</p>
            </div>
            <h3 class="eb-quiz__education-question">${this.escapeHtml(question.question)}</h3>
            <div class="eb-quiz__options">
              ${question.options.map((option, i) => `
                <button class="eb-quiz__option" data-option-index="${i}" data-option-value="${this.escapeHtml(option)}">${this.escapeHtml(option)}</button>
              `).join('')}
            </div>
          </div>
        `;
      }
  
      renderSlider(question) {
        return `
          <div class="eb-quiz__slider">
            <h2 class="eb-quiz__question-title">${this.escapeHtml(question.question)}</h2>
            <div class="eb-quiz__slider-value" data-slider-value>${this.sliderValue}</div>
            <input type="range" class="eb-quiz__slider-input" min="${question.min}" max="${question.max}" value="${this.sliderValue}" data-slider-input>
            <div class="eb-quiz__slider-labels"><span>Not urgent</span><span>Extremely urgent</span></div>
            <button class="eb-quiz__slider-btn" data-slider-submit>Continue →</button>
          </div>
        `;
      }
  
      bindOptionEvents(question) {
        if (question.type === 'single' || question.type === 'education') {
          this.elements.questionContainer.querySelectorAll('.eb-quiz__option').forEach(btn => {
            btn.addEventListener('click', () => this.selectOption(question, btn.dataset.optionValue));
          });
        }
  
        if (question.type === 'multi') {
          this.elements.questionContainer.querySelectorAll('.eb-quiz__option').forEach(btn => {
            btn.addEventListener('click', () => this.toggleMultiOption(question, btn));
          });
        }
  
        if (question.type === 'breather') {
          const breatherBtn = this.elements.questionContainer.querySelector('[data-breather-continue]');
          if (breatherBtn) breatherBtn.addEventListener('click', () => this.goNext());
        }
  
        if (question.type === 'slider') {
          const slider = this.elements.questionContainer.querySelector('[data-slider-input]');
          const valueDisplay = this.elements.questionContainer.querySelector('[data-slider-value]');
          const submitBtn = this.elements.questionContainer.querySelector('[data-slider-submit]');
  
          if (slider) {
            slider.addEventListener('input', (e) => {
              this.sliderValue = parseInt(e.target.value);
              valueDisplay.textContent = this.sliderValue;
              this.updateSliderBackground(slider);
            });
            this.updateSliderBackground(slider);
          }
  
          if (submitBtn) {
            submitBtn.addEventListener('click', () => {
              this.answers[question.id] = this.sliderValue;
              QuizAnalytics.trackQuestionAnswer(this.currentStep + 1, question.id, this.sliderValue, Date.now() - this.questionStartTime);
              this.goNext();
            });
          }
        }
      }
  
      updateSliderBackground(slider) {
        const value = (slider.value - slider.min) / (slider.max - slider.min) * 100;
        slider.style.background = `linear-gradient(to right, var(--eb-primary) 0%, var(--eb-primary) ${value}%, var(--eb-gray-200) ${value}%, var(--eb-gray-200) 100%)`;
      }
  
      selectOption(question, value) {
        this.elements.questionContainer.querySelectorAll('.eb-quiz__option').forEach(btn => {
          btn.classList.toggle('eb-quiz__option--selected', btn.dataset.optionValue === value);
        });
  
        this.answers[question.id] = value;
        QuizAnalytics.trackQuestionAnswer(this.currentStep + 1, question.id, value, Date.now() - this.questionStartTime);
  
        if (question.segmentKey) {
          const segment = this.config.results[value]?.segment || 'unknown';
          QuizAnalytics.trackSegment('morning_profile', segment);
        }
  
        setTimeout(() => this.goNext(), 300);
      }
  
      toggleMultiOption(question, btn) {
        const value = btn.dataset.optionValue;
        let selected = this.answers[question.id] || [];
  
        if (selected.includes(value)) {
          selected = selected.filter(v => v !== value);
          btn.classList.remove('eb-quiz__option--selected');
        } else {
          selected.push(value);
          btn.classList.add('eb-quiz__option--selected');
        }
  
        this.answers[question.id] = selected;
        this.updateContinueButton(question);
      }
  
      updateContinueButton(question) {
        if (question.type === 'multi') {
          const selected = this.answers[question.id] || [];
          this.elements.continueBtn.style.display = 'block';
          const hasSelection = selected.length > 0;
          this.elements.continueBtn.classList.toggle('eb-quiz__continue-btn--active', hasSelection);
          this.elements.continueBtn.disabled = !hasSelection;
        } else {
          this.elements.continueBtn.style.display = 'none';
        }
      }
  
      updateProgress() {
        const progress = ((this.currentStep + 1) / this.config.questions.length) * 100;
        this.elements.progressFill.style.width = `${progress}%`;
        this.elements.currentStepEl.textContent = this.currentStep + 1;
      }
  
      goNext() {
        const question = this.config.questions[this.currentStep];
        
        if (question.type === 'multi') {
          QuizAnalytics.trackQuestionAnswer(this.currentStep + 1, question.id, this.answers[question.id] || [], Date.now() - this.questionStartTime);
        }
  
        if (this.currentStep < this.config.questions.length - 1) {
          this.currentStep++;
          this.renderQuestion();
        } else {
          this.showLoading();
        }
      }
  
      goBack() {
        if (this.currentStep > 0) {
          this.currentStep--;
          this.renderQuestion();
        }
      }
  
      handleAbandon() {
        if (!this.completed && this.currentStep > 0) {
          const question = this.config.questions[this.currentStep];
          QuizAnalytics.trackQuizAbandon(this.currentStep + 1, question?.id, Date.now() - this.quizStartTime);
        }
      }
  
      showLoading() {
        this.elements.quizContainer.style.display = 'none';
        this.elements.loadingScreen.style.display = 'flex';
  
        let progress = 0;
        let testimonialIndex = 0;
        const loadingStages = [
          { threshold: 25, text: 'Analyzing your responses...' },
          { threshold: 50, text: 'Identifying your morning type...' },
          { threshold: 75, text: 'Finding your personalized protocol...' },
          { threshold: 100, text: 'Generating your results...' }
        ];
  
        const testimonialInterval = setInterval(() => {
          testimonialIndex = (testimonialIndex + 1) % this.config.testimonials.length;
          const t = this.config.testimonials[testimonialIndex];
          this.elements.testimonialQuote.textContent = `"${t.quote}"`;
          this.elements.testimonialAuthor.textContent = `— ${t.author}`;
        }, 2500);
  
        const progressInterval = setInterval(() => {
          progress += 2;
          this.elements.loadingProgress.style.width = `${progress}%`;
          const stage = loadingStages.find(s => progress <= s.threshold);
          if (stage) this.elements.loadingText.textContent = stage.text;
  
          if (progress >= 100) {
            clearInterval(progressInterval);
            clearInterval(testimonialInterval);
            setTimeout(() => this.showResults(), 500);
          }
        }, 100);
      }
  
      showResults() {
        this.completed = true;
        this.elements.loadingScreen.style.display = 'none';
        this.elements.resultsScreen.style.display = 'block';
  
        const result = this.config.results[this.answers.struggle] || Object.values(this.config.results)[0];
        QuizAnalytics.trackQuizComplete(this.answers, result.type, Date.now() - this.quizStartTime);
        this.elements.resultsScreen.innerHTML = this.renderResultsPage(result);
        this.bindResultsEvents(result);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
  
      renderResultsPage(result) {
      const testimonials = this.config.resultTestimonials || [];
      return `
        <div class="eb-quiz__results-hero">
        <p class="eb-quiz__results-label">Your Morning Profile</p>
          ${result.image ? `<img src="${result.image}" alt="${this.escapeHtml(result.type)}" class="eb-quiz__results-hero-image">` : ''}
          <p class="eb-quiz__results-diagnosis">${this.escapeHtml(result.diagnosis)}</p>
        </div>
          <div class="eb-quiz__results-content">
            <div class="eb-quiz__results-card">
              <h2 class="eb-quiz__results-card-title">Why Everything Else Failed</h2>
              <p>You've been trying to solve a <strong>three-layer problem</strong> with single-layer solutions:</p>
              <div class="eb-quiz__results-problems">
                <div class="eb-quiz__results-problem"><div class="eb-quiz__results-problem-icon">💧</div><div class="eb-quiz__results-problem-title">Dehydration</div><div class="eb-quiz__results-problem-desc">You lose 1+ lb of water overnight</div></div>
                <div class="eb-quiz__results-problem"><div class="eb-quiz__results-problem-icon">⚡</div><div class="eb-quiz__results-problem-title">Energy Crash</div><div class="eb-quiz__results-problem-desc">Coffee spikes cortisol, then crashes</div></div>
                <div class="eb-quiz__results-problem"><div class="eb-quiz__results-problem-icon">🧠</div><div class="eb-quiz__results-problem-title">Brain Fog</div><div class="eb-quiz__results-problem-desc">No nootropics to clear the haze</div></div>
              </div>
              <p>Alarm clocks, willpower, and coffee only address one layer. <strong>You need a three-layer solution.</strong></p>
            </div>
            <div class="eb-quiz__results-protocol">
              <h2 class="eb-quiz__results-protocol-title">Your Personalized Protocol</h2>
              <div class="eb-quiz__results-protocol-rec"><div class="eb-quiz__results-protocol-rec-label">Recommended</div><div class="eb-quiz__results-protocol-rec-value">${this.escapeHtml(result.solution)}</div></div>
              <h3 class="eb-quiz__results-ritual-title">The Nightstand Ritual:</h3>
              <div class="eb-quiz__results-ritual-steps">
                <div class="eb-quiz__results-ritual-step"><div class="eb-quiz__results-ritual-num">1</div><div class="eb-quiz__results-ritual-text">Night before: Mix one scoop with water, place on nightstand</div></div>
                <div class="eb-quiz__results-ritual-step"><div class="eb-quiz__results-ritual-num">2</div><div class="eb-quiz__results-ritual-text">Alarm goes off: Reach over, shake, drink</div></div>
                <div class="eb-quiz__results-ritual-step"><div class="eb-quiz__results-ritual-num">3</div><div class="eb-quiz__results-ritual-text">Within 10-15 minutes: Feel the switch flip</div></div>
                <div class="eb-quiz__results-ritual-step"><div class="eb-quiz__results-ritual-num">4</div><div class="eb-quiz__results-ritual-text">Execute your morning routine with energy and clarity</div></div>
              </div>
            </div>
            <div class="eb-quiz__results-card">
              <h2 class="eb-quiz__results-card-title" style="text-align:center;">People Like You Are Saying...</h2>
              <div class="eb-quiz__results-testimonials">
                ${testimonials.map(t => `<div class="eb-quiz__results-testimonial"><p class="eb-quiz__results-testimonial-quote">"${this.escapeHtml(t.quote)}"</p><div class="eb-quiz__results-testimonial-meta"><span class="eb-quiz__results-testimonial-author">— ${this.escapeHtml(t.author)}</span><span class="eb-quiz__results-testimonial-tag">${this.escapeHtml(t.tag)}</span></div></div>`).join('')}
              </div>
            </div>
            <div class="eb-quiz__results-cta">
           <img src="https://cdn.shopify.com/s/files/1/0043/9382/8423/files/hero-image-02-benefit-callout.png?v=1769569767" alt="EarlyBird Morning Cocktail" class="eb-quiz__results-cta-hero">
              <h2 class="eb-quiz__results-cta-title">Ready to Transform Your Mornings?</h2>
              <p class="eb-quiz__results-cta-benefit">${this.escapeHtml(result.benefit)}</p>
              <button class="eb-quiz__results-cta-btn" data-cta-main>Start Your Morning Transformation →</button>
              <div class="eb-quiz__results-cta-guarantees"><span>✓ 60-Day Money-Back Guarantee</span><span>✓ Free Shipping</span><span>✓ Cancel Anytime</span></div>
            </div>
            <p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>
          </div>
        `;
      }
  
      bindResultsEvents(result) {
        const ctaBtn = this.elements.resultsScreen.querySelector('[data-cta-main]');
        if (ctaBtn) {
          ctaBtn.addEventListener('click', () => {
            QuizAnalytics.trackCTAClick('main_cta', result.type);
            window.location.href = '/pages/new-dynamic-golife';
          });
        }
      }
  
      addToCart(variantId) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1, properties: { '_quiz_profile': this.config.results[this.answers.struggle]?.type || '', '_quiz_session': QuizAnalytics.sessionId } }]
          })
        })
        .then(res => res.json())
        .then(() => window.location.href = '/cart')
        .catch(() => window.location.href = `/products/${this.config.productHandle}`);
      }
  
      escapeHtml(str) {
        if (!str) return '';
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
      }
    }
  
    // Initialize
    function initQuiz() {
      document.querySelectorAll('#earlybird-quiz').forEach(container => new EarlyBirdQuiz(container));
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initQuiz);
    } else {
      initQuiz();
    }
  
    window.EarlyBirdQuiz = EarlyBirdQuiz;
    window.EarlyBirdQuizAnalytics = QuizAnalytics;
  })();